import React from 'react'
import Text from 'src/components/Text'
import { ConsultReceivementButton, Form } from './ConsultReceivementForm.style'
import { FieldValues, UseFormRegister } from 'react-hook-form'
import TextFieldMui from 'src/components/TextFieldMui'

interface ConsultReceivementFormProps {
  onSubmit: React.FormEventHandler<HTMLFormElement>
  register: UseFormRegister<FieldValues>
  formTitle: string,
  submitButtonLabel?: string,
}

export const ConsultReceivementForm = ({
  onSubmit, register, formTitle, submitButtonLabel = 'Consultar recebimento',
}: ConsultReceivementFormProps) => (
  <>
    <Text plainText={formTitle} />
    <Form onSubmit={onSubmit}>
      <TextFieldMui
        inputProps={{ ...register('badge', { required: true }), 'data-testid': 'badge-input' }}
        name='Crachá'
        type='password'
        autoComplete='off'
        size='medium'
        margin='none'
      />
      <TextFieldMui
        inputProps={{ ...register('attendancePassword', { required: true }), 'data-testid': 'attendance-password-input' }}
        name='Senha de Atendimento'
        type='text'
        autoComplete='off'
        size='medium'
        margin='none'
      />

      <ConsultReceivementButton variant='contained' size='large' type='submit' data-testid='consult-receivement-button'>{submitButtonLabel}</ConsultReceivementButton>
    </Form>
  </>
)
